function LicensesActions() {
    return <div id="licenses-drawer" />;
}

export default LicensesActions;
